export default {
    pmusers_new_user: "Nuevo usuario",
    pmusers_edit_user: "Editar usuario",
    pmusers_user_has_been_created: "El usuario ha sido creado",
    pmusers_user_has_been_edited: "El usuario ha sido editado",
    pmusers_user_firstname: "Nombre",
    pmusers_user_lastName: "Apellido",
    pmusers_user_username: "Nombre de usuario",
    pmusers_user_email: "Correo electrónico",
    pmusers_user_email_is_invalid: "El correo electrónico no es válido",
    pmusers_user_password: "Contraseña",
    pmusers_user_repeat_password: "Repita la contraseña",
    pmusers_user_rol: "Roles",

    pmusers_min_chars_firname: "El nombre debe contener un mínimo de caracteres:",
    pmusers_max_chars_firname: "El nombre debe contener un máximo de caracteres:",

    pmusers_min_chars_lastname: "El apellido debe contener un mínimo de caracteres:",
    pmusers_max_chars_lastname: "El apellido debe contener un máximo de caracteres:",

    pmusers_min_chars_username: "El nombre de usuario debe contener un mínimo de caracteres:",
    pmusers_max_chars_username: "El nombre de usuario debe contener el máximo de caracteres:",

    pmusers_min_chars_password: "La contraseña debe contener un mínimo de caracteres:",
    pmusers_max_chars_password: "La contraseña debe contener el máximo de caracteres:",

    pmusers_message_error_create: "No se ha podido crear el usuario debido a un error",
    pmusers_message_error_edit: "No se puede editar el usuario debido a un error",

    pmusers_is_restricted: "Es Restringido?",
    pmusers_dealers: "Restringido para ver estos distribuidores",
    pmusers_dealer: "Distribuidor"
}